import { render, staticRenderFns } from "./CharacterFaceSelector.vue?vue&type=template&id=62fdfb0e&lang=pug&"
import script from "./CharacterFaceSelector.vue?vue&type=script&lang=ts&"
export * from "./CharacterFaceSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterFaceSelector.vue"
export default component.exports